
import React from 'react';
import { format } from 'date-fns';
import { Card, CardContent } from '@/components/ui/card';
import { CycleData } from '@/utils/cycle-tracking';
import { Droplets, Calendar, Activity } from 'lucide-react';

interface CycleStatCardsProps {
  cycleData: CycleData | null;
}

export const CycleStatCards: React.FC<CycleStatCardsProps> = ({ cycleData }) => {
  if (!cycleData) return null;
  
  const { periodStartDate, predictedOvulation, predictedNextPeriod } = cycleData;
  
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
      <Card className="bg-white border-hormony-beige/50">
        <CardContent className="p-4 flex items-center">
          <div className="w-10 h-10 rounded-full bg-hormony-light-coral flex items-center justify-center mr-3">
            <Droplets className="h-5 w-5 text-hormony-coral" />
          </div>
          <div>
            <div className="text-sm text-muted-foreground">Last Period</div>
            <div className="font-medium text-hormony-charcoal">
              {format(periodStartDate, 'MMM d')}
              <span className="text-xs text-muted-foreground ml-1">
                ({format(periodStartDate, 'yyyy')})
              </span>
            </div>
          </div>
        </CardContent>
      </Card>
      
      <Card className="bg-white border-hormony-beige/50">
        <CardContent className="p-4 flex items-center">
          <div className="w-10 h-10 rounded-full bg-hormony-cream flex items-center justify-center mr-3">
            <Activity className="h-5 w-5 text-hormony-coral" />
          </div>
          <div>
            <div className="text-sm text-muted-foreground">Next Ovulation</div>
            <div className="font-medium text-hormony-charcoal">
              {format(predictedOvulation, 'MMM d')}
              <span className="text-xs text-muted-foreground ml-1">
                ({Math.round((predictedOvulation.getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24))} days)
              </span>
            </div>
          </div>
        </CardContent>
      </Card>
      
      <Card className="bg-white border-hormony-beige/50">
        <CardContent className="p-4 flex items-center">
          <div className="w-10 h-10 rounded-full bg-hormony-beige flex items-center justify-center mr-3">
            <Calendar className="h-5 w-5 text-hormony-taupe" />
          </div>
          <div>
            <div className="text-sm text-muted-foreground">Next Period</div>
            <div className="font-medium text-hormony-charcoal">
              {format(predictedNextPeriod, 'MMM d')}
              <span className="text-xs text-muted-foreground ml-1">
                ({Math.round((predictedNextPeriod.getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24))} days)
              </span>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
